import * as types from "../types/businessTypes";

const initialState = {
  isLoading: true,
  isError: null,
  list: [],
};

export default function reducer(state = initialState, action) {
  const { type, payload } = action;

  switch (type) {
    case types.IS_LOADING:
      return { ...state, isLoading: payload };
    case types.IS_ERROR:
      return { ...state, isError: payload };
    case types.LIST:
      return { ...state, list: payload };
    default:
      return state;
  }
}
